const groupByAlpha = arr => {
    const data = arr.reduce((r, e) => {
        let group = e.name[0];
        if(!r[group]) r[group] = {group, children: [e]}
        else r[group].children.push(e);
        return r;
    }, {});
    return Object.values(data).sort(compare);
}, groupByCity = arr => {
    const data = arr.reduce((r, e) => {
        let group = e.city;
        if(!r[group]) r[group] = {group, children: [e]}
        else r[group].children.push(e);
        return r;
    }, {});
    return Object.values(data).sort(compare);
}, compare = (a, b) => {
    if (a.group < b.group)
      return -1;
    if (a.group > b.group)
      return 1;
    return 0;
  };

export default {
    state: {
        loadingStores: false,
        statusOk: null,
        errMessage: "",
        okMessage: "",
        storesByAlphabet: [],
        storesByCity: []
    },
    mutations: {
        'STORES_LOADING' (state, val) {
            state.loadingStores = val;
        },
        'STORES_LOADING_SUCCESS' (state, val) {
            state.statusOk = true;
            const stores = val.response;
            state.storesByAlphabet = groupByAlpha(stores);
            state.storesByCity = groupByCity(stores);
            state.errMessage = "";
        },
        'STORES_LOADING_POSTS_ERROR' (state, val) {
            state.statusOk = false;
            state.errMessage = val;
            state.okMessage = "";
        }
    },
    actions: {
        'STORES_FETCH' ({commit}) {
            /* eslint-disable */
            commit('STORES_LOADING', true);
            axios.get(`/store`)
            .then(resp => {
                commit('STORES_LOADING', false);
                commit('STORES_LOADING_SUCCESS', resp.data);
                console.log("all stores", resp);
            })
            .catch(err => {
                commit('STORES_LOADING', false);
                commit('STORES_LOADING_SUCCESS', {response: demo});
                //commit('STORES_LOADING_ERROR', 'Error. Server error');
                console.log("all stores err", err);
            });
        }
    }
};

const demo = [];
for(let i=0;i<20;i++) {
    demo.push({
        _id: i,
        name: Math.random().toString(36).substring(7),
        country: "Finland",
        province: "Uusimaa",
        city: Math.random().toString(36).substring(7),
        totalItemsForSale: Math.floor((Math.random() * 100) + 1)
    });
}